webpackJsonp([8],{

/***/ 177:
/***/ (function(module, exports) {

module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.1f2677eca7e5e698ecde.js